import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import {
  showModal,
  confirmModal,
  cancelModal,
} from '@store/actions/commonAction';
import {
  verifySms,
  reCertificateSms,
  verifiMobileCertificate,
  reReqMobileCertificate,
  smsPc,
  verifySmsFail,
} from '@store/actions/userAction';

import Timer from '@components/common/Timer';
import SatNumberKeypad from '@components/common/satUI/SatNumberKeypad';

import { setReceiveKeyEventOnOff } from '@common/utils/device';

const LoginAuthorization = () => {
  const input1Ref = useRef();
  const input2Ref = useRef();
  const input3Ref = useRef();
  const input4Ref = useRef();
  const input5Ref = useRef();
  const input6Ref = useRef();

  const {
    userInfo,
    authInfo: { authSms },
    notMatchInfo: { isNotMatch, mobileNo },
    loginInfo: {
      device: { applicationDeviceCode },
      isSearchId,
    },
  } = useSelector(state => state.userReducer);

  const history = useHistory();
  const dispatch = useDispatch();

  const [timer, setTimer] = useState({ visible: true, error: '', failCnt: 0 });
  const [authNum, setAuthNum] = useState([
    { ref: input1Ref, val: '' },
    { ref: input2Ref, val: '' },
    { ref: input3Ref, val: '' },
    { ref: input4Ref, val: '' },
    { ref: input5Ref, val: '' },
    { ref: input6Ref, val: '' },
  ]);
  const [keypadOpen, setKeypadOpen] = useState(false);

  useEffect(() => {
    const clean = () => {
      setTimer({ visible: true, error: '' });
      setAuthNum([
        { ref: input1Ref, val: '' },
        { ref: input2Ref, val: '' },
        { ref: input3Ref, val: '' },
        { ref: input4Ref, val: '' },
        { ref: input5Ref, val: '' },
        { ref: input6Ref, val: '' },
      ]);
      dispatch(verifySmsFail({ error: '' }));
    };
    return clean;
  }, []);

  useEffect(() => {
    if (authNum && authNum.filter(item => item.val !== '').length === 0) {
      input1Ref.current.focus();
    } else if (
      authNum &&
      authNum.filter(item => item.val !== '').length === 6
    ) {
      if (applicationDeviceCode === '02') {
        // setKeypadOpen(false);
        dispatch(
          confirmModal(() => {
            window.removeEventListener(
              'setReceiveKeyEventOnOffCallBack',
              setReceiveKeyEventOnOffCallBack,
              false,
            );
            window.removeEventListener(
              'receiveKeyEvent',
              receiveKeyEvent,
              false,
            );

            setReceiveKeyEventOnOff(false);
          }),
        );
      }
      onVerifyButtonClickHandler();
    }
  }, [authNum]);

  useEffect(() => {
    if (authSms.error !== '') {
      setTimer({ ...timer, error: authSms.error, failCnt: authSms.failCnt });
      setAuthNum([
        { ref: input1Ref, val: '' },
        { ref: input2Ref, val: '' },
        { ref: input3Ref, val: '' },
        { ref: input4Ref, val: '' },
        { ref: input5Ref, val: '' },
        { ref: input6Ref, val: '' },
      ]);
    }
  }, [authSms]);

  useEffect(() => {
    window.addEventListener(
      'setReceiveKeyEventOnOffCallBack',
      setReceiveKeyEventOnOffCallBack,
      false,
    );
    setReceiveKeyEventOnOff(true);

    return () => {
      window.removeEventListener(
        'setReceiveKeyEventOnOffCallBack',
        setReceiveKeyEventOnOffCallBack,
        false,
      );
      window.removeEventListener('receiveKeyEvent', receiveKeyEvent, false);

      setReceiveKeyEventOnOff(false);
    };
  }, []);
  /**
   * input change Event
   * @param {Event} e
   * @param {Number} index
   */
  const onInputChangeHandler = (e, index) => {
    const { value } = e.target;

    const checkNum = val => {
      const regExp = /[0-9]/g;
      if (regExp.test(val)) {
        return true;
      }
      return false;
    };

    if (!checkNum(value)) {
      return;
    }

    // 인풋 값 변화에 따른 authNum 셋팅
    setAuthNum(
      authNum.map((num, idx) => {
        return idx === index ? { ...num, val: value } : num;
      }),
    );

    // 포커스 이동
    if (value !== '' && index !== 5) {
      authNum[index + 1].ref.current.focus();
    }
  };

  /**
   * '인증번호 재요청' 버튼 클릭 이벤트
   */
  const onRetryButtonClickHandler = () => {
    setAuthNum([
      { ref: input1Ref, val: '' },
      { ref: input2Ref, val: '' },
      { ref: input3Ref, val: '' },
      { ref: input4Ref, val: '' },
      { ref: input5Ref, val: '' },
      { ref: input6Ref, val: '' },
    ]);

    if (timer.error !== '') {
      setTimer({ visible: true, error: '' });
    } else {
      setTimer({ visible: false, error: '' });
      setTimeout(() => {
        setTimer({ visible: true, error: '' });
      }, 200);
    }

    if (isNotMatch) {
      dispatch(reReqMobileCertificate());
    } else {
      dispatch(reCertificateSms());
    }
  };
  /**
   * '인증번호 확인' 버튼 클릭 이벤트
   */
  const onVerifyButtonClickHandler = () => {
    // 입력횟수 초과
    if (timer.failCnt >= 5) {
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: '인증 횟수를 초과하였습니다.',
        }),
      );

      return;
    }

    // 인증번호 입력 시간 초과
    if (timer.error === 'timeout') {
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: '유효시간이 초과하였습니다.',
        }),
      );

      return;
    }
    // 인증번호 입력 확인
    if (authNum.filter(item => item.val === '').length > 0) {
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: '인증번호를 입력하세요.',
        }),
      );

      return;
    }

    if (isNotMatch) {
      dispatch(verifiMobileCertificate(authNum.map(item => item.val).join('')));
    } else {
      // PC-ID(사번)을 잊으셨나요? 를 통해 화면접속
      if (isSearchId) {
        dispatch(
          smsPc({
            authNo: authNum.map(item => item.val).join(''),
            certiMode: '02', // ID찾기:02
          }),
        );
      } else {
        // 인증번호 확인
        dispatch(verifySms(authNum.map(item => item.val).join('')));
      }
    }
  };

  useEffect(() => {
    if (keypadOpen) {
      setTimeout(() => {
        showNumberKeypad();
      }, 300);
    }
  }, [keypadOpen]);

  const onFocusHandler = () => {
    if (applicationDeviceCode === '02') {
      setKeypadOpen(true);
    }
  };

  const onKeyDownHandler = (e, index) => {
    // del
    if (e.keyCode === 8) {
      setAuthNum(
        authNum.map((num, idx) => {
          return idx === index - 1 ? { ...num, val: '' } : num;
        }),
      );

      // 포커스 이동
      if (index !== 0) {
        authNum[index - 1].ref.current.focus();
      }
    }
  };

  const keypadRef = useRef();
  const setReceiveKeyEventOnOffCallBack = ({ data: { isOn } }) => {
    if (isOn) {
      window.addEventListener('receiveKeyEvent', receiveKeyEvent, false);
    }
  };

  const receiveKeyEvent = ({ data }) => {
    if (keypadRef && keypadRef.current) {
      keypadRef.current.setInputKeyEvent(data);
    }
  };

  const closeNumberKeypad = () => {
    dispatch(
      cancelModal(() => {
        if (applicationDeviceCode === '02') {
          window.removeEventListener(
            'setReceiveKeyEventOnOffCallBack',
            setReceiveKeyEventOnOffCallBack,
            false,
          );
          window.removeEventListener('receiveKeyEvent', receiveKeyEvent, false);
          setReceiveKeyEventOnOff(false);
          setKeypadOpen(false);
        }
      }),
    );
  };

  const showNumberKeypad = () => {
    dispatch(
      showModal({
        visible: true,
        type: 'slide',
        render: () => (
          <SatNumberKeypad
            ref={keypadRef}
            key={`auth_input`}
            type={'number'}
            title={'인증번호 6자리'}
            numValue={authNum.map(item => item.val).join('')}
            validGuide={''}
            maxLength={'6'}
            useMobile={false}
            onOk={value => {
              handleNumberKeypadComplete(value);
              setKeypadOpen(false);
            }}
            onClose={closeNumberKeypad}
          />
        ),
        setVisible: closeNumberKeypad,
      }),
    );
  };
  const handleNumberKeypadComplete = val => {
    setAuthNum(
      authNum.map((item, idx) => {
        if (idx > val.length - 1) {
          return { ...item, val: '' };
        } else if (idx === val.length - 1) {
          return { ...item, val: val.slice(-1) };
        } else {
          return { ...item, val: val.slice(idx, idx + 1) };
        }
      }),
    );

    dispatch(
      confirmModal(() => {
        window.removeEventListener(
          'setReceiveKeyEventOnOffCallBack',
          setReceiveKeyEventOnOffCallBack,
          false,
        );
        window.removeEventListener('receiveKeyEvent', receiveKeyEvent, false);

        setReceiveKeyEventOnOff(false);
      }),
    );
  };

  return (
    <>
      <div className="page-navi">
        <button
          type="button"
          className="btn-back"
          onClick={() => history.goBack()}
        >
          <span className="hide">이전</span>
        </button>
      </div>
      <p className="tit">
        <span className="num">{isNotMatch ? mobileNo : userInfo.cpNo}</span>로
        보내드린
        <br />
        <strong>인증번호</strong>를 입력해주세요.
      </p>
      <div className="logincon-area">
        <div className={`verification-num ${timer.error !== '' && 'error'}`}>
          {authNum &&
            authNum.map((item, index) => (
              <input
                id={`authNumInput-${index}`}
                key={`authNum-${index}`}
                ref={item.ref}
                inputMode="none"
                autoComplete="off"
                value={item.val}
                maxLength={1}
                className={`input ${item.val !== '' && 'val'}`}
                onChange={e => onInputChangeHandler(e, index)}
                onFocus={e => onFocusHandler(e, index)}
                onKeyDown={e => onKeyDownHandler(e, index)}
              />
            ))}
        </div>
        <div className="btn-area">
          {timer.visible && timer.error === '' && (
            <p className="text-info blue">
              인증코드 유효시간
              <Timer
                type="min"
                time={600}
                callback={() => {
                  setTimer(prevState => {
                    return {
                      ...prevState,
                      error: 'timeout',
                    };
                  });
                }}
              />
            </p>
          )}
          {timer.error !== '' && (
            <p className="text-info ico-type error">
              {timer.failCnt >= 5
                ? '인증횟수 5회 이상 실패하였습니다. 인증번호 재요청버튼을 눌러 다시 입력하세요.'
                : timer.error === 'wrong'
                ? `인증번호가 다릅니다. 다시 시도해주세요.(${timer.failCnt}/5)`
                : '유효시간이 만료되었습니다. 인증번호 재요청버튼을 눌러 다시 입력하세요.'}
            </p>
          )}
          <button
            type="button"
            className="btn-s blue side-r"
            onClick={onRetryButtonClickHandler}
          >
            인증번호 재요청
          </button>
        </div>
      </div>
      <div className="btn-area">
        <button
          type="button"
          className="btn-l blue"
          onClick={onVerifyButtonClickHandler}
        >
          인증번호 확인
        </button>
      </div>
    </>
  );
};

export default LoginAuthorization;
